module.exports = __webpack_public_path__ + "img/229.c6f94cf4.jpg";